import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { borderRadius, breakpoints, colors, spacing } = useTheme();

  return {
    facilitiesWrapper: css`
      border: 1px solid ${colors.bright_grey};
      border-radius: ${borderRadius.l};
    `,
    facilities: css`
      display: grid;
      grid-template-columns: 24px 1fr;
      align-items: flex-start;
      grid-row-gap: ${spacing.xs};
      border-top: 1px solid ${colors.lightGrey};
      padding: 10px 0;

      ${breakpoints.m} {
        border-top: 0;
        padding: 0;
      }
    `,
    title: css`
      color: ${colors.navy};
      text-align: center;
      font-size: 18px;
      letter-spacing: -0.01em;

      ${breakpoints.l} {
        font-size: 25.9px;
        display: grid;
        align-content: center;
      }
    `,
    subtitle: css`
      color: ${colors.darkGrey};
      text-align: center;
      position: relative;

      &:last-child {
        word-spacing: ${borderRadius.s};
      }

      ${breakpoints.l} {
        color: ${colors.darkGrey};
        align-content: center;
      }
      ${breakpoints.mm_m_l}{
        font-size: 1rem;
      }
      ${breakpoints.mm_s_m}{
        font-size: 1rem;
      }
      ${breakpoints.mm_xs_s}{
        font-size: 1rem;
      }
      ${breakpoints.mm_xxs_xs}{
        font-size: 1rem;
      }
    `,
    positionWrapper: css`
      align-content: center;
      background-color: ${colors.pale_blue};
      padding: ${borderRadius.l};
    `,
    postion: css`
      text-align: center;
      border-radius: ${borderRadius.l} solid;
      color: ${colors.navy};
      font-size: 18px;
      letter-spacing: -0.01em;

      ${breakpoints.l} {
        font-size: 21.6px;
        letter-spacing: -0.01em;
      }
    `,
    infoFacilities: css`
      background-color: ${colors.alice_blue};
      padding: ${spacing.s};

      ${breakpoints.m} {
        padding: 1.5rem;
      }
    `,
    seasonText: css`
      font-size: 0.875rem;
    `,
  };
};